// contact-api.js
import { ProtectedHttpClient, PublicHttpClient } from "../shared/clients/http-client";
const ContactApi = {
  private: {
    getContacts: (params = {}) => ProtectedHttpClient.post("/contacts?page=1&limit=1000", params), // Requires token
    getContactDetails: (contactId) => ProtectedHttpClient.get(`/contact/${contactId}`), // Requires token
    createContact: (data) => ProtectedHttpClient.post("/contact", data), // Requires token
    updateContact: (contactId, data) => ProtectedHttpClient.patch(`/contact/${contactId}`, data), // Requires token
    deleteContact: (contactId) => ProtectedHttpClient.delete(`/contact/${contactId}`), // Requires token
    getRoomLink: (contactId) => ProtectedHttpClient.get(`/contact/${contactId}/generate-room-link`), // Requires token
    getWeChatQrLink: (contactId) => ProtectedHttpClient.get(`/contact/${contactId}/wechat-qr-link`), // Requires token
    checkIfContactExists: (payload) => ProtectedHttpClient.post(`/contact/check`, payload), // Requires token
  },
};

export default ContactApi;
